import { useEffect } from "react";

export default function ExternalRedirect({ url }) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return null;
}
